<template>
  <div class="info-card flex column center-all">
    <!-- FLAT ICON -->
    <span
      v-if="flatIcon"
      class="header-icon flat-icon"
      :style="flatIconStyle" />

    <!-- ICON -->
    <SBIcon
      v-if="icon"
      class="header-icon"
      :icon="icon"
      :color="iconColor"
      :size="36"/>

    <!-- TITLE -->
    <h5
      v-if="title" >{{ title }}</h5>

    <!-- DESCRIPTION -->
    <!-- No user input is rendered here. -->
    <!-- eslint-disable vue/no-v-html  -->
    <div
      v-if="description"
      class="description pre-lined"
      v-html="description" />
    <!-- eslint-enable vue/no-v-html  -->

    <!-- ACTION -->
    <div
      v-if="action"
      class="action">
      <b-button
        class="flex center-all"
        @click="triggerAction">
        <SBIcon
          class="mr-2"
          :icon="actionIcon"
          :color="SBColors.blackPrimary"
          :size="8"/>
        <span>{{ actionText }}</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';

export default {
  name: 'InfoCard',
  components: {
    SBIcon,
  },
  props: {
    icon: {
      type: Object,
      required: false,
      default: null,
    },
    iconColor: {
      type: String,
      required: false,
      default: SBColors.blackPrimary,
    },
    flatIcon: {
      type: Object,
      required: false,
      default: null,
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
    description: {
      type: String,
      required: false,
      default: null,
    },
    action: {
      type: Boolean,
      required: false,
      default: true,
    },
    actionIcon: {
      type: Object,
      required: false,
      default: () => SBIconList.PLUS,
    },
    actionText: {
      type: String,
      required: false,
      default: 'Add',
    },
  },
  data() {
    return {
      SBColors,
      SBIconList,
    };
  },
  computed: {
    flatIconStyle() {
      return {
        background: `url(${this.iconData()})`,
      };
    },
  },
  methods: {
    /**
     * Returns the image data as base64 for the required image.
     */
    iconData() {
      // eslint-disable-next-line
      return require(`@/assets/img/SB-Icons/${this.flatIcon.fileName}`);
    },
    triggerAction() {
      this.$emit('action');
    },
  },
};
</script>

<style lang="scss" scoped>
.info-card {
  margin: 35px 0 35px 0;
  padding: 28px;
  // max-width: 782px;
  border: 1px solid #e1e5eb;
  border-radius: 15px;
  background-color: #f8fbff;

  .header-icon {
    margin-bottom: 15px;

    &.flat-icon {
      width: 36px;
      height: 36px;
      background-position: center!important;
      background-repeat: no-repeat !important;
      background-size: contain !important;
    }
  }

  h5 {
    color: $blackPrimary;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
  }

  .description {
    color: $blackUltralight;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 40px;
    text-align: center;
    max-width: 474px;

    ::v-deep a {
      color: $blackUltralight;
      text-decoration: underline;
    }
  }

  .action {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
  }

  :last-child {
    margin-bottom: 0;
  }
}
</style>
